
















































































import { env } from '@hb/mbridge';
import { Component, Vue } from 'vue-property-decorator';
import { navigateTo, versionCompare } from '~mall/common/utils/rentUtils';
import { QueryCouponGoodsProductDetailList } from '~mall/model/apis/ticketApis';
import logger from '~mall/common/utils/logger';
import { Tag, QueryCouponGoodsProductDetailListRsp, Product } from './QueryCouponGoodsProductDetailList.d';


@Component
export default class RentCouponCard extends Vue {
    products: Product[] = [];

    isShowAllProduct = false;

    public mounted() {
      QueryCouponGoodsProductDetailList({
        ids: [this.$route.query.spuId],
      })
        .then((res: QueryCouponGoodsProductDetailListRsp) => {
          logger('res: ', res);
          if (!res || !res.products) return;
          this.products = res.products;
          if (res.isShowAllProduct) {
            let isShowRentModule = true;
            if (env.isEasyBikeApp && versionCompare(env.appVersion, '6.16.0') < 0) {
              isShowRentModule = false;
            }

            this.isShowAllProduct = isShowRentModule;
          }
        });
    }

    showColor2BgColor = (color: string) => {
      const lists = {
        yellow: {
          color: '#C99E67',
          background: '#FFF8EF',
        },
        red: {
          color: '#F25656',
          background: '#FEF6F6',
        },
        white: {
          color: '#5a6066',
          background: '#bcc4cc',
        },
      };

      return lists[color.toLowerCase()];
    };

    setStyle = (tag: Tag) => {
      if (tag.showColor) {
        return this.showColor2BgColor(tag.showColor);
      }
      return {};
    };

    jumpToModelDetail(productId?: string) {
      if (!productId) return;

      navigateTo({
        miniPath: `/pages/modelDetail/index?modelId=${productId}`,
        appPath: `hellobike://hellobike.com/new_detail?modelId=${productId}&type=2`,
      });
    }

    goToHome() {
      navigateTo({
        miniPath: '/pages/homepage/index',
        appPath: 'hellobike://hellobike.com/evehicle/shop',
      });
    }
}
